import React, { useEffect } from 'react'
import { Link } from 'gatsby'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Image from '@components/Image'

const MOCKDATA: RealEstateDataPageComponentData = {
  image:
    'https://images.pexels.com/photos/2078774/pexels-photo-2078774.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  title: 'Desde 1994 brindando el mejor servicio.',
  is_wide: false,
  subtitle: 'SOBRE NOSOTROS',
  paragraph:
    'En 1994 decidió emprender su propia inmobiliaria independiente. Planteó su proyecto pensando en las interacciones humanas que incluyen cualquier negociación inmobiliaria como una relación de largo plazo. En ella, el respeto, la transparencia, la constante actitud de servicio y el profesionalismo son vitales.',
  button: {
    link: 'nosotros',
    value: 'CONOCÉ MÁS',
    border: false,
  },
}

const AboutUs_7 = (props: RealEstateDataPageComponentData) => {
  const { isDemo } = props
  const {
    image_gatsby,
    image_right_gatsby,
    title,
    subtitle,
    paragraph,
    paragraphs,
    button,
    is_wide,
  } = isDemo ? MOCKDATA : props

  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])

  const headers = (
    <>
      <h4 className="subtitle">{subtitle}</h4>
      <h2 className="title mt-lg-4  ">{title}</h2>
    </>
  )

  return (
    <section className={'about-us g position-relative p-y-config ' + (is_wide ? ' is-wide ' : '')}>
      {image_right_gatsby && (
        <Image
          className="w-100 about-img-right-bottom position-absolute no-border"
          objectFit="cover"
          alt="about-us-img"
          image={image_right_gatsby!}
        />
      )}
      <Container fluid>
        <Row>
          <Col
            xs={12}
            // data-aos="fade-right"
            className="d-block d-lg-none text-center"
          >
            {headers}
          </Col>
          <Col
            xs={12}
            lg={6}
            className="is-wide-image"
            // data-aos="fade-right"
          >
            {/* <img src={image} alt="About Us" className="about-us-img" /> */}
            <Image
              className="w-100 about-us-img no-border"
              objectFit="cover"
              alt="about-us-img"
              image={image_gatsby!}
            />
          </Col>
          <Col
            xs={12}
            lg={{ span: 6, offset: is_wide ? 6 : 0 }}
            className="ps-lg-5 d-flex align-items-start justify-content-center flex-column"
            // data-aos="fade-right"
          >
            <div className="d-flex flex-column contenedor align-items-center justify-content-center">
              <div className="d-none d-lg-block">{headers}</div>
              {paragraph ? (
                <p className="text-content mt-5 mt-lg-5 mb-0 text-center text-lg-start">
                  {paragraph}
                </p>
              ) : null}
              {paragraphs && paragraphs?.length > 0 ? (
                <>
                  {paragraphs?.map((p, i) => (
                    <p
                      className="text-content mt-5 mt-lg-4 mb-0 text-center text-lg-start"
                      key={i}
                    >
                      {p}
                    </p>
                  ))}
                </>
              ) : null}
              {button?.value && button?.link && (
                <Link
                  to={button?.link || ''}
                  className={
                    'btn btn-primary m-auto m-lg-5 ms-lg-0 mt-5 ' + (button?.border ? 'border' : '')
                  }
                >
                  {button?.value}
                </Link>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs_7
